export const GET_AI_VALUE_BOARD = `
  query GetAiValueBoard($element3Map: String, $element4Map: String) {
    getAiValueBoard(element3Map: $element3Map, element4Map: $element4Map) {
      workloadId
      workloadName
      modelId
      ytdActualCost
      estimateDollar
      projectedAnnualEstimate
      investmentProspectRatio
      investmentProspectBand
    }
  }
`

export const GET_AI_VALUE_OPPORTUNITY = `
  query GetAiValueOpportunity($element3Map: String, $element4Map: String) {
    getAiValueOpportunity(element3Map: $element3Map, element4Map: $element4Map) {
      costSavingOpportunity
      revenueDrivingOpportunity
    }
  }
`
